<template>
  <div>
    <el-breadcrumb separator-icon="ArrowRight" style="margin: 16px" class="hide-on-mobile">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人信息</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card style="margin: 15px; min-height: calc(100vh - 111px)">
      <!-- ========== 移动端 ========== -->
      <div v-if="isMobile" class="mobile-selfinfo">
        <!-- 头像区域 -->
        <div class="mobile-avatar-section">
          <div class="avatar-circle">
            <span class="avatar-text">{{ form.name ? form.name.charAt(0) : '?' }}</span>
          </div>
          <div class="avatar-info">
            <div class="avatar-name">{{ form.name || '未知' }}</div>
            <div class="avatar-id">学号: {{ form.username || '-' }}</div>
          </div>
        </div>

        <!-- 信息卡片 -->
        <div class="mobile-info-card">
          <div class="info-card-header">
            <span class="info-card-title">基本信息</span>
            <el-button type="primary" size="small" icon="Edit" @click="edit" text>编辑</el-button>
          </div>
          <div class="info-row">
            <span class="info-label">性别</span>
            <span class="info-value">{{ form.gender || '未设置' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">年龄</span>
            <span class="info-value">{{ form.age || '未设置' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">手机号</span>
            <span class="info-value">{{ form.phone_num || '未设置' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">邮箱</span>
            <span class="info-value">{{ form.email || '未设置' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">单位</span>
            <span class="info-value">{{ form.unit || '未设置' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">班级</span>
            <span class="info-value">{{ form.class_num || '未分配' }}</span>
          </div>
        </div>

        <!-- 宿舍卡片 -->
        <div class="mobile-info-card">
          <div class="info-card-header">
            <span class="info-card-title">住宿信息</span>
          </div>
          <div class="info-row">
            <span class="info-label">宿舍</span>
            <span class="info-value" v-if="form.dormRoom && form.dormRoom.dormBuildId">
              {{ form.dormRoom.dormBuildId + '-' + form.dormRoom.dormRoomId }}
            </span>
            <span class="info-value info-empty" v-else>未分配</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="mobile-action-buttons">
          <el-button type="primary" size="large" icon="Edit" @click="edit" class="action-btn">编辑信息</el-button>
          <el-button type="warning" size="large" icon="Lock" @click="showChangePassword" class="action-btn">修改密码</el-button>
        </div>
      </div>

      <!-- ========== PC端 ========== -->
      <div v-else class="pc-selfinfo">
        <div class="self-info-wrapper">
          <div class="self-info-card">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="账号">{{ form.username }}</el-descriptions-item>
              <el-descriptions-item label="姓名">{{ form.name }}</el-descriptions-item>
              <el-descriptions-item label="性别">{{ form.gender || '未设置' }}</el-descriptions-item>
              <el-descriptions-item label="年龄">{{ form.age || '未设置' }}</el-descriptions-item>
              <el-descriptions-item label="手机号">{{ form.phone_num || '未设置' }}</el-descriptions-item>
              <el-descriptions-item label="邮箱">{{ form.email || '未设置' }}</el-descriptions-item>
              <el-descriptions-item label="班级">{{ form.class_num || '未分配' }}</el-descriptions-item>
              <el-descriptions-item label="单位">{{ form.unit || '未设置' }}</el-descriptions-item>
              <el-descriptions-item label="宿舍" v-if="form.dormRoom && form.dormRoom.dormBuildId">
                {{ form.dormRoom.dormBuildId + '-' + form.dormRoom.dormRoomId }}
              </el-descriptions-item>
              <el-descriptions-item label="宿舍" v-else>
                <span style="color: #999">未分配</span>
              </el-descriptions-item>
            </el-descriptions>
            <div style="margin-top: 20px; text-align: center; display: flex; gap: 12px; justify-content: center;">
              <el-button type="primary" icon="Edit" @click="edit">编辑信息</el-button>
              <el-button type="warning" icon="Lock" @click="showChangePassword">修改密码</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- ========== 编辑信息弹窗 ========== -->
      <el-dialog v-model="dialogVisible" :title="isMobile ? '编辑个人信息' : '编辑个人信息'" :width="isMobile ? '92%' : '30%'" @close="cancel">
        <!-- 移动端编辑表单 -->
        <div v-if="isMobile" class="mobile-edit-form">
          <div class="mobile-form-group">
            <div class="mobile-form-label">账号</div>
            <el-input :model-value="editData.username" disabled size="large" />
          </div>
          <div class="mobile-form-group">
            <div class="mobile-form-label">姓名 <span class="required-star">*</span></div>
            <el-input v-model="editData.name" placeholder="请输入姓名" size="large" />
            <div v-if="editErrors.name" class="mobile-form-error">{{ editErrors.name }}</div>
          </div>
          <div class="mobile-form-group">
            <div class="mobile-form-label">性别 <span class="required-star">*</span></div>
            <el-radio-group v-model="editData.gender" size="large">
              <el-radio-button label="男">男</el-radio-button>
              <el-radio-button label="女">女</el-radio-button>
            </el-radio-group>
            <div v-if="editErrors.gender" class="mobile-form-error">{{ editErrors.gender }}</div>
          </div>
          <div class="mobile-form-group">
            <div class="mobile-form-label">年龄</div>
            <el-input v-model.number="editData.age" placeholder="请输入年龄" size="large" type="number" />
          </div>
          <div class="mobile-form-group">
            <div class="mobile-form-label">手机号 <span class="required-star">*</span></div>
            <el-input v-model="editData.phone_num" placeholder="请输入手机号" size="large" maxlength="11" />
            <div v-if="editErrors.phone_num" class="mobile-form-error">{{ editErrors.phone_num }}</div>
          </div>
          <div class="mobile-form-group">
            <div class="mobile-form-label">邮箱</div>
            <el-input v-model="editData.email" placeholder="请输入邮箱" size="large" />
            <div v-if="editErrors.email" class="mobile-form-error">{{ editErrors.email }}</div>
          </div>
        </div>
        <!-- PC端编辑表单 -->
        <el-form v-else ref="editForm" :model="editData" :rules="editRules" label-width="100px">
          <el-form-item label="账号">
            <el-input :model-value="editData.username" disabled style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="editData.name" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-radio v-model="editData.gender" label="男">男</el-radio>
            <el-radio v-model="editData.gender" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input v-model.number="editData.age" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone_num">
            <el-input v-model="editData.phone_num" style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="editData.email" style="width: 80%"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </template>
      </el-dialog>

      <!-- ========== 修改密码弹窗 ========== -->
      <el-dialog v-model="pwdDialogVisible" title="修改密码" :width="isMobile ? '92%' : '30%'" @close="cancelPwd">
        <!-- 移动端密码表单 -->
        <div v-if="isMobile" class="mobile-edit-form">
          <div class="mobile-form-group">
            <div class="mobile-form-label">当前密码 <span class="required-star">*</span></div>
            <el-input v-model="pwdData.oldPassword" type="password" show-password placeholder="请输入当前密码" size="large" />
            <div v-if="pwdErrors.oldPassword" class="mobile-form-error">{{ pwdErrors.oldPassword }}</div>
          </div>
          <div class="mobile-form-group">
            <div class="mobile-form-label">新密码 <span class="required-star">*</span></div>
            <el-input v-model="pwdData.newPassword" type="password" show-password placeholder="请输入新密码(6-32位)" size="large" />
            <div v-if="pwdErrors.newPassword" class="mobile-form-error">{{ pwdErrors.newPassword }}</div>
          </div>
          <div class="mobile-form-group">
            <div class="mobile-form-label">确认密码 <span class="required-star">*</span></div>
            <el-input v-model="pwdData.confirmPassword" type="password" show-password placeholder="请再次输入新密码" size="large" />
            <div v-if="pwdErrors.confirmPassword" class="mobile-form-error">{{ pwdErrors.confirmPassword }}</div>
          </div>
        </div>
        <!-- PC端密码表单 -->
        <el-form v-else ref="pwdForm" :model="pwdData" :rules="pwdRules" label-width="100px">
          <el-form-item label="当前密码" prop="oldPassword">
            <el-input v-model="pwdData.oldPassword" type="password" show-password style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input v-model="pwdData.newPassword" type="password" show-password style="width: 80%"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input v-model="pwdData.confirmPassword" type="password" show-password style="width: 80%"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="cancelPwd">取 消</el-button>
          <el-button type="primary" @click="savePwd">确 定</el-button>
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>
<script src="@/assets/js/SelfInfo.js"></script>
<style scoped>
/* PC端 */
.pc-selfinfo .self-info-wrapper { display: flex; justify-content: center; padding: 20px; }
.pc-selfinfo .self-info-card { max-width: 700px; width: 100%; }

/* ========== 移动端样式 ========== */
.mobile-selfinfo { padding: 4px 0; }

/* 头像区域 */
.mobile-avatar-section {
  display: flex;
  align-items: center;
  padding: 20px 16px;
  background: linear-gradient(135deg, #409eff 0%, #79bbff 100%);
  border-radius: 12px;
  margin-bottom: 16px;
}
.avatar-circle {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255,255,255,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.avatar-text {
  font-size: 24px;
  color: #fff;
  font-weight: 600;
}
.avatar-info { margin-left: 14px; }
.avatar-name { font-size: 18px; font-weight: 600; color: #fff; }
.avatar-id { font-size: 13px; color: rgba(255,255,255,0.85); margin-top: 2px; }

/* 信息卡片 */
.mobile-info-card {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.info-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}
.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  border-bottom: 1px solid #f5f5f5;
}
.info-row:last-child { border-bottom: none; }
.info-label { font-size: 14px; color: #909399; }
.info-value { font-size: 14px; color: #303133; text-align: right; }
.info-empty { color: #c0c4cc !important; }

/* 操作按钮 */
.mobile-action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}
.mobile-action-buttons .action-btn {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  font-size: 15px;
}

/* 移动端表单 */
.mobile-edit-form { padding: 4px 0; }
.mobile-form-group { margin-bottom: 18px; }
.mobile-form-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 6px;
  font-weight: 500;
}
.required-star { color: #f56c6c; }
.mobile-form-error {
  font-size: 12px;
  color: #f56c6c;
  margin-top: 4px;
  line-height: 1.2;
}

/* 响应式 */
@media (max-width: 768px) {
  .hide-on-mobile { display: none; }
}
@media (min-width: 769px) {
  .hide-on-mobile { display: block; }
}
</style>
